import i18n from '@/i18n';
import { initFormBlock } from '../setting-page/constants';
import { state } from '@/state/modules/manager-form.js';
import { FORMAT_VALUE_PHONE, FORMAT_VALUE_INPUT } from '../../handlers';
import { ALL_BLOCK_TYPE } from '@/config/constants';

const configFormInput = (data = null) => {
    return {
        configFieldNameBlock: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.nameBlock'),
            errorCustomMess: '',
            valueSync: data?.block_name ? data.block_name : '',
            typesValidate: ['required', 'max500']
        },
        configFieldLabelBlock: {
            isRequired: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.label'),
            errorCustomMess: '',
            valueSync: data?.label ? data.label : '',
            typesValidate: ['required'],
            editorOption: {
                placeholder: ''
            }
        },
        configFieldLabel_Q_Block1: {
            isRequired: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.label1Div_2'),
            errorCustomMess: '',
            valueSync: data?.block_div_2?.label_q ? data.block_div_2.label_q : '',
            typesValidate: ['required'],
            editorOption: {
                placeholder: ''
            }
        },
        configFieldLabel_A_Block2: {
            isRequired: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.label2Div_2'),
            errorCustomMess: '',
            valueSync: data?.block_div_2?.label_a ? data.block_div_2.label_a : '',
            typesValidate: ['required'],
            editorOption: {
                placeholder: ''
            }
        },
        configFieldMaxCharacters: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.maxCharacters'),
            errorCustomMess: '',
            valueSync: data?.max_characters ? data.max_characters : '255',
            min: 1,
            max: data?.input_format?.type_input === 'numerical_value' ? 10 : 255,
            typesValidate: ['required', 'max255', 'limit-input']
        },
        configFieldNumberOfDigits: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.numberOfDigits'),
            errorCustomMess: '',
            valueSync: data?.block_input?.number_of_digits ? data.block_input.number_of_digits : 15,
            min: 1,
            max: 1000,
            typesValidate: ['required', 'max255', 'limit-input']
        },
        configFieldNumberOfDecimalPlaces: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.numberOfDecimalPlaces'),
            errorCustomMess: '',
            valueSync: data?.block_input?.number_of_decimal_places ? data.block_input.number_of_decimal_places : 5,
            min: 0,
            max: 100,
            typesValidate: ['required', 'max255', 'limit-input']
        },
        configFieldPhonePlaceholder_1: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.placeholderPhone1'),
            errorCustomMess: '',
            valueSync: data?.block_phone?.placeholder_1 ? data.block_phone.placeholder_1 : '',
            typesValidate: ['max255']
        },
        configFieldPhonePlaceholder_2: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.placeholderPhone2'),
            errorCustomMess: '',
            valueSync: data?.block_phone?.placeholder_2 ? data.block_phone.placeholder_2 : '',
            typesValidate: ['max255']
        },
        configFieldPhonePlaceholder_3: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.placeholderPhone3'),
            errorCustomMess: '',
            valueSync: data?.block_phone?.placeholder_3 ? data.block_phone.placeholder_3 : '',
            typesValidate: ['max255']
        },
        configFieldPlaceholderYear: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: `年は`,
            errorCustomMess: '',
            valueSync: data?.block_date?.format_year?.placeholder ? data.block_date.format_year.placeholder : '',
            typesValidate: ['max255']
        },
        configFieldPlaceholderMonth: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: '月',
            errorCustomMess: '',
            valueSync: data?.block_date?.format_month_day?.placeholder_month ? data.block_date.format_month_day.placeholder_month : '',
            typesValidate: ['max255']
        },
        configFieldPlaceholderDay: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: '日',
            errorCustomMess: '',
            valueSync: data?.block_date?.format_month_day?.placeholder_day ? data.block_date.format_month_day.placeholder_day : '',
            typesValidate: ['max255']
        },
        configFieldLowerLimit: {
            min: 1800,
            max: 2100,
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.lowerLimit'),
            errorCustomMess: '',
            valueSync: data?.block_date?.format_year?.lower_limit ? data.block_date.format_year.lower_limit : '',
            typesValidate: ['max255', 'limit-input']
        },
        configFieldUpperLimit: {
            min: 1800,
            max: 2100,
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.upperLimit'),
            errorCustomMess: '',
            valueSync: data?.block_date?.format_year?.upper_limit ? data.block_date.format_year.upper_limit : '',
            typesValidate: ['max255', 'limit-input']
        },
        configFieldMaximumFileSize: {
            min: 1,
            max: 50,
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.maximumFileSize'),
            errorCustomMess: '',
            valueSync: data?.block_upload_file.maximum_file_size ? data.block_upload_file.maximum_file_size : '',
            typesValidate: ['required', 'limit-input']
        },
        configFieldAllowedExtensions: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.allowedExtensions'),
            errorCustomMess: '',
            valueSync: data?.block_upload_file.allowed_extensions ? data.block_upload_file.allowed_extensions : '',
            typesValidate: ['max255']
        },
        configFieldMinimumNumber: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.minimumNumber'),
            errorCustomMess: '',
            valueSync: data?.block_input?.minimum_number ? data.block_input.minimum_number : '',
            min: 1,
            max: 255,
            typesValidate: ['max255', 'limit-input']
        },
        configFieldMaximumNumber: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.maximumNumber'),
            errorCustomMess: '',
            valueSync: data?.block_input?.maximum_number ? data.block_input.maximum_number : '',
            min: 1,
            max: 255,
            typesValidate: ['max255', 'limit-input']
        },
        configFieldFromRange: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.rangeOfValidAnswerValue'),
            errorCustomMess: '',
            valueSync: data?.block_input?.from_range ? data.block_input.from_range : '',
            min: '-2147483648',
            max: '2147483647',
            maxlength: data?.input_format?.type_input === 'numerical_value' ? 11 : '',
            integer:
                data?.block_input?.number_of_digits && data?.block_input?.number_of_decimal_places
                    ? Number(data?.block_input?.number_of_digits) - Number(data?.block_input?.number_of_decimal_places)
                    : 10,
            decimal: data?.block_input.number_after_decimal_point
                ? Number(data?.block_input.number_after_decimal_point)
                : data?.block_input?.number_of_decimal_places
                  ? Number(data?.block_input?.number_of_decimal_places)
                  : 5,
            typesValidate: data?.input_format?.type_input === 'numerical_value' ? ['integerMaxMin'] : ['integerDecimal']
        },
        configFieldToRange: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.rangeOfValidAnswerValue'),
            errorCustomMess: '',
            valueSync: data?.block_input?.to_range ? data.block_input.to_range : '',
            min: '-2147483648',
            max: '2147483647',
            maxlength: data?.input_format?.type_input === 'numerical_value' ? 11 : '',
            integer:
                data?.block_input?.number_of_digits && data?.block_input?.number_of_decimal_places
                    ? Number(data?.block_input?.number_of_digits) - Number(data?.block_input?.number_of_decimal_places)
                    : 10,
            decimal: data?.block_input.number_after_decimal_point
                ? Number(data?.block_input.number_after_decimal_point)
                : data?.block_input?.number_of_decimal_places
                  ? Number(data?.block_input?.number_of_decimal_places)
                  : 5,
            typesValidate: data?.input_format?.type_input === 'numerical_value' ? ['integerMaxMin'] : ['integerDecimal']
        },
        configFieldNumberAfterDecimalPoint: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            messageCustom: true,
            errorField: '',
            errorCustomMess: '',
            valueSync: data?.block_input?.number_after_decimal_point ? data.block_input.number_after_decimal_point : '',
            typesValidate: []
        },
        configFieldInputPlaceholder: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.placeholderCommon'),
            errorCustomMess: '',
            valueSync: data?.placeholder || '',
            typesValidate: ['max255']
        },
        configFieldInputLastNamePlaceholder: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.lastName'),
            errorCustomMess: '',
            valueSync: data?.block_full_name?.placeholder_last_name ? data.block_full_name.placeholder_last_name : '',
            typesValidate: ['max255']
        },
        configFieldInputFirstNamePlaceholder: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.firstName'),
            errorCustomMess: '',
            valueSync: data?.block_full_name?.placeholder_first_name ? data.block_full_name.placeholder_first_name : '',
            typesValidate: ['max255']
        },
        configFieldPostcodePlaceholder1: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: `上3桁`,
            errorCustomMess: '',
            maxlength: '',
            valueSync: data?.block_post_code?.placeholder_1 ? data.block_post_code.placeholder_1 : '',
            typesValidate: ['max255']
        },
        configFieldPostcodePlaceholder2: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: `下4桁`,
            errorCustomMess: '',
            maxlength: '',
            valueSync: data?.block_post_code?.placeholder_2 ? data.block_post_code.placeholder_2 : '',
            typesValidate: ['max255']
        },
        configFieldRowTextarea: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.heightIs'),
            errorCustomMess: '',
            valueSync: data?.block_text_area?.rows ? data.block_text_area.rows : '',
            min: 1,
            max: 100,
            typesValidate: ['limit-input']
        },
        configFieldColumnsTextarea: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.widthIs'),
            errorCustomMess: '',
            valueSync: data?.block_text_area?.cols ? data.block_text_area.cols : '',
            min: 1,
            max: 200,
            typesValidate: ['limit-input']
        },
        configFieldInputFieldSize: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.inputFieldSize'),
            errorCustomMess: '',
            valueSync: data?.input_field_size ? data.input_field_size : '',
            min: 1,
            max: 200,
            typesValidate: ['max255', 'limit-input']
        },
        configFieldPlaceholder: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.placeholderSelect'),
            errorCustomMess: '',
            valueSync: data?.placeholder ? data.placeholder : '',
            typesValidate: ['max20']
        },
        configFieldLabelOther: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: `${i18n.t('managerForm.settingPage.others')}(${i18n.t('managerForm.settingPage.labelOther')})`,
            errorCustomMess: '',
            valueSync: data?.setting_others?.label_other ? data.setting_others.label_other : 'その他',
            typesValidate: ['required', 'max20']
        },
        configFieldWidthOther: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: `${i18n.t('managerForm.settingPage.others')}(${i18n.t('managerForm.settingPage.widthOther')})`,
            errorCustomMess: '',
            valueSync: data?.setting_others?.width_other ? data.setting_others.width_other : '',
            min: 1,
            max: 200,
            typesValidate: ['max255', 'limit-input']
        },
        configFieldLabelUncheck: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: `${i18n.t('managerForm.settingPage.uncheckCheckbox')}${i18n.t('managerForm.settingPage.labelOther')}`,
            errorCustomMess: '',
            valueSync: data?.setting_others?.label_uncheck ? data.setting_others.label_uncheck : i18n.t('managerForm.settingPage.uncheckCheckbox'),
            typesValidate: ['required', 'max20']
        },
        configFieldNumberLimitCheck: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.checkNumberLimit'),
            errorCustomMess: '',
            valueSync: data?.block_checkbox.number_limit_check ? data.block_checkbox.number_limit_check : '',
            min: 1,
            max: 149,
            typesValidate: data?.block_checkbox.number_limit_check ? ['required', 'max255', 'limit-input'] : ['max255', 'limit-input']
        },
        configFieldRemainingLabelOther: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.labelOther'),
            errorCustomMess: '',
            valueSync: data?.block_remaining_number?.label_other ? data.block_remaining_number.label_other : '',
            typesValidate: ['max255']
        },
        configFieldRemainingRatio: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.remainingRatio'),
            errorCustomMess: '',
            valueSync: data?.block_remaining_number?.remaining_ratio ? data.block_remaining_number.remaining_ratio : '',
            min: '1',
            max: '99',
            typesValidate: ['max255', 'limit-input']
        },
        configFieldRemainingText: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.remainingText'),
            errorCustomMess: '',
            valueSync: data?.block_remaining_number?.remaining_text ? data.block_remaining_number.remaining_text : '',
            typesValidate: ['max255']
        },
        configFieldTextAfterremainingnumber: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.textAfterremainingnumber'),
            errorCustomMess: '',
            valueSync: data?.block_remaining_number?.text_after_remaining_number ? data.block_remaining_number.text_after_remaining_number : '',
            typesValidate: ['max255']
        },
        configFieldKeywordUpload: {
            error: false,
            errorField: i18n.t('managerForm.settingPage.keywordUpload'),
            errorCustomMess: '',
            valueSync: data?.block_keyword_box?.keyword_characters ? data.block_keyword_box.keyword_characters : '',
            length: data?.max_characters ? Number(data.max_characters) : 32,
            maxTotal: 1000000,
            typesValidate: ['requiredCustomMsg', 'maxCustom', 'maxTotal']
        },
        configFieldParamName: {
            error: false,
            errorField: i18n.t('managerForm.settingPage.paramName'),
            length: 30,
            errorCustomMess: '',
            valueSync: data?.block_parameter?.param_name ? data.block_parameter.param_name : '',
            typesValidate: ['required', 'maxCustom']
        },
        configFieldCustomHeight: {
            isNumber: true,
            isMaxLength: false,
            error: false,
            errorField: 'スクロールの高さ',
            length: 30,
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max5']
        },
        configFieldParamUrl: {
            error: false,
            errorField: i18n.t('managerForm.settingPage.errorRedirectDestination'),
            errorCustomMess: '',
            valueSync: data?.block_parameter?.error_redirect_url ? data.block_parameter.error_redirect_url : '',
            typesValidate: ['max255', 'url']
        },

        configFieldLeftBlock: {
            isRequired: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.positionLeftNoteBlock'),
            errorCustomMess: '',
            valueSync: data?.additional_setting?.note_left_block ? data.additional_setting.note_left_block : '',
            typesValidate: [],
            editorOption: {
                placeholder: ''
            }
        },
        configFieldRightBlock: {
            isRequired: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.positionRightNoteBlock'),
            errorCustomMess: '',
            valueSync: data?.additional_setting?.note_right_block ? data.additional_setting.note_right_block : '',
            typesValidate: [],
            editorOption: {
                placeholder: ''
            }
        },
        configFieldBottomBlock: {
            isRequired: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.positionBottomNoteBlock'),
            errorCustomMess: '',
            valueSync: data?.additional_setting?.note_bottom_block ? data.additional_setting.note_bottom_block : '',
            typesValidate: [],
            editorOption: {
                placeholder: ''
            }
        },

        validateArrayOption: initFormBlock(data).option_value.map((o) => {
            return {
                configFieldValue: {
                    isRequired: false,
                    error: false,
                    errorField: `${TABLE_OPTION_BLOCK_COMMON.headers[1].label}[${o?.unique_key}行目]`,
                    errorCustomMess: '',
                    valueSync: o.value ? o.value : '',
                    typesValidate: ['required', 'max500']
                },
                configFieldNumberOfReceptions: {
                    isNumber: true,
                    isRequired: false,
                    error: false,
                    errorField: `${TABLE_OPTION_BLOCK_COMMON.headersRemaining[2].label}[${o?.unique_key}行目]`,
                    errorCustomMess: '',
                    valueSync: o.number_of_receptions ? o.number_of_receptions : '',
                    min: 1,
                    max: 10000,
                    typesValidate: ['required', 'max255', 'limit-input']
                }
            };
        }),

        validateArrayErrMsg: state().listMessageBlocks.map((o) => {
            return {
                configFieldErrorMsg: {
                    isRequired: false,
                    error: false,
                    errorField: o.label,
                    errorCustomMess: '',
                    valueSync: o.messages ? o.messages : '',
                    typesValidate: ['required', 'max100']
                }
            };
        })
    };
};

const handleAddConfigOptions = (validateArrayOption, optionValue) => {
    validateArrayOption = optionValue.map((o, idx) => {
        const varConfigValue = validateArrayOption[idx]?.configFieldValue;
        const varConfigNumberOfReceptions = validateArrayOption[idx]?.configFieldNumberOfReceptions;
        return {
            configFieldValue: {
                isRequired: varConfigValue?.isRequired ?? false,
                error: varConfigValue?.error ?? false,
                errorField: `${TABLE_OPTION_BLOCK_COMMON.headers[1].label}[${o?.unique_key}行目]`,
                errorCustomMess: varConfigValue?.errorCustomMess ?? '',
                valueSync: o.value ? o.value : '',
                typesValidate: varConfigValue?.typesValidate ?? ['required', 'max500']
            },
            configFieldNumberOfReceptions: {
                isNumber: varConfigNumberOfReceptions?.isNumber ?? true,
                isRequired: varConfigNumberOfReceptions?.isRequired ?? false,
                error: varConfigNumberOfReceptions?.error ?? false,
                errorField: `${TABLE_OPTION_BLOCK_COMMON.headersRemaining[2].label}[${o?.unique_key}行目]`,
                errorCustomMess: varConfigNumberOfReceptions?.errorCustomMess ?? '',
                valueSync: o.number_of_receptions ? o.number_of_receptions : '',
                min: varConfigNumberOfReceptions?.min ?? 1,
                max: varConfigNumberOfReceptions?.max ?? 10000,
                typesValidate: varConfigNumberOfReceptions?.typesValidate ?? ['required', 'max255', 'limit-input']
            }
        };
    });
    return validateArrayOption;
};

const CONFIRMATION_PAGE_DISPLAY = [
    {
        id: 1,
        name: '表示する'
    },
    {
        id: 2,
        name: '表示しない'
    }
];

const LIST_TEXT_ALIGN = [
    {
        id: 4,
        label: '共通デザインを適用する',
        value: 'default'
    },
    {
        id: 1,
        label: '左寄せ',
        value: 'left'
    },
    {
        id: 2,
        label: '中央揃え',
        value: 'center'
    },
    {
        id: 3,
        label: '右寄せ',
        value: 'right'
    }
];

const LAYOUT_TYPE = [
    {
        id: 1,
        label: '共通デザインを適用する',
        value: 'default'
    },
    {
        id: 2,
        label: '横並び',
        value: 'row'
    },
    {
        id: 3,
        label: '縦並び',
        value: 'cols'
    }
];

const LIST_CHOICE_CONDITION = [
    {
        id: 1,
        label: 'AND条件',
        value: 'AND'
    },
    {
        id: 2,
        label: 'OR条件',
        value: 'OR'
    }
];

const MATCH_CHOICE_CONDITION = [
    {
        id: 1,
        value: '入力不可'
    },
    {
        id: 2,
        value: '非表示'
    }
];

const TABLE_OPTION_BLOCK_COMMON = {
    headers: [
        {
            label: 'ID',
            required: false,
            width: 50
        },
        {
            label: '選択肢',
            required: true
        },
        {
            label: 'コマンド',
            required: false
        }
    ],
    headersRemaining: [
        {
            label: 'ID',
            required: false,
            width: 50
        },
        {
            label: '選択肢',
            required: true
        },
        {
            label: '受付数',
            required: true
        },
        {
            label: 'コマンド',
            required: false
        }
    ]
};

const TABLE_CONDITION_BLOCK = {
    headers: [
        {
            label: '項目',
            width: '250'
        },
        {
            label: '条件',
            width: '180'
        },
        {
            label: '値',
            width: '200'
        },
        {
            label: 'コマンド',
            width: '100'
        }
    ]
};

const TABLE_ERROR_MESSAGES = {
    headers: [
        {
            label: 'エラー内容',
            width: '250',
            required: false
        },
        {
            label: 'メッセージ',
            width: '250',
            required: true
        },
        {
            label: 'コマンド',
            width: '250',
            required: false
        }
    ]
};

const TYPE_CONDITION_IN_TABLE = [
    {
        id: 1,
        value: 'いずれか選択'
    },
    {
        id: 2,
        value: '回答なし'
    },
    {
        id: 3,
        value: '回答あり'
    }
];

const OPTION_LIMIT_CHECK = [
    {
        id: 1,
        value: '='
    },
    {
        id: 2,
        value: '≧'
    },
    {
        id: 3,
        value: '≦'
    }
];

const OPTION_INPUT_FORMAT = [
    {
        id: 1,
        value: '指定無し',
        type_input: 'not_specified'
    },
    {
        id: 2,
        value: 'メールアドレス',
        type_input: 'email'
    },
    {
        id: 3,
        value: '数字(0-9)',
        type_input: 'number'
    },
    {
        id: 4,
        value: '半角英数字',
        type_input: 'half-width_alphanumeric_characters'
    },
    {
        id: 5,
        value: '全角文字',
        type_input: 'full-width_characters'
    },
    {
        id: 6,
        value: 'ひらがな',
        type_input: 'hiragana'
    },
    {
        id: 7,
        value: '全角カタカナ',
        type_input: 'full-width_katakana'
    },
    {
        id: 8,
        value: '半角カタカナ',
        type_input: 'half-width_katakana'
    },
    {
        id: 9,
        value: '数値',
        type_input: 'numerical_value'
    },
    {
        id: 10,
        value: '数値(小数点を含む)',
        type_input: 'numeric_value_including_decimal_point'
    }
];

const OPTION_INPUT_FORMAT_FULL_NAME = [
    {
        id: 1,
        value: '指定無し',
        type_input: 'not_specified',
        first_name: '姓',
        last_name: '名'
    },
    {
        id: 2,
        value: 'ひらがな',
        type_input: 'hiragana',
        first_name: 'せい',
        last_name: 'めい'
    },
    {
        id: 3,
        value: 'カタカナ',
        type_input: 'katakana',
        first_name: 'セイ',
        last_name: 'メイ'
    },
    {
        id: 4,
        value: '全角カタカナ',
        type_input: 'full-width_katakana',
        first_name: 'セイ',
        last_name: 'メイ'
    },
    {
        id: 5,
        value: '半角カタカナ',
        type_input: 'half-width_katakana',
        first_name: 'ｾｲ',
        last_name: 'ﾒｲ'
    }
];

const OPTION_YES_NO = [
    {
        id: 1,
        value: '使用する'
    },
    {
        id: 2,
        value: '使用しない'
    }
];

const OPTION_FORMAT_DATE = [
    {
        id: 1,
        value: 'テキスト'
    },
    {
        id: 2,
        value: 'セレクト'
    }
];

const OPTION_CALENDAR_WEST_TIME = [
    {
        id: 1,
        value: '西暦'
    },
    {
        id: 2,
        value: '和暦'
    },
    {
        id: 3,
        value: '西暦・和暦'
    }
];

const LIST_PROVINCE_BLOCK = () => {
    return [
        {
            unique_key: 1,
            value: '北海道'
        },
        {
            unique_key: 2,
            value: '青森県'
        },
        {
            unique_key: 3,
            value: '岩手県'
        },
        {
            unique_key: 4,
            value: '宮城県'
        },
        {
            unique_key: 5,
            value: '秋田県'
        },
        {
            unique_key: 6,
            value: '山形県'
        },
        {
            unique_key: 7,
            value: '福島県'
        },
        {
            unique_key: 8,
            value: '茨城県'
        },
        {
            unique_key: 9,
            value: '栃木県'
        },
        {
            unique_key: 10,
            value: '群馬県'
        },
        {
            unique_key: 11,
            value: '埼玉県'
        },
        {
            unique_key: 12,
            value: '千葉県'
        },
        {
            unique_key: 13,
            value: '東京都'
        },
        {
            unique_key: 14,
            value: '神奈川県'
        },
        {
            unique_key: 15,
            value: '新潟県'
        },
        {
            unique_key: 16,
            value: '富山県'
        },
        {
            unique_key: 17,
            value: '石川県'
        },
        {
            unique_key: 18,
            value: '福井県'
        },
        {
            unique_key: 19,
            value: '山梨県'
        },
        {
            unique_key: 20,
            value: '長野県'
        },
        {
            unique_key: 21,
            value: '岐阜県'
        },
        {
            unique_key: 22,
            value: '静岡県'
        },
        {
            unique_key: 23,
            value: '愛知県'
        },
        {
            unique_key: 24,
            value: '三重県'
        },
        {
            unique_key: 25,
            value: '滋賀県'
        },
        {
            unique_key: 26,
            value: '京都府'
        },
        {
            unique_key: 27,
            value: '大阪府'
        },
        {
            unique_key: 28,
            value: '兵庫県'
        },
        {
            unique_key: 29,
            value: '奈良県'
        },
        {
            unique_key: 30,
            value: '和歌山県'
        },
        {
            unique_key: 31,
            value: '鳥取県'
        },
        {
            unique_key: 32,
            value: '島根県'
        },
        {
            unique_key: 33,
            value: '岡山県'
        },
        {
            unique_key: 34,
            value: '広島県'
        },
        {
            unique_key: 35,
            value: '山口県'
        },
        {
            unique_key: 36,
            value: '徳島県'
        },
        {
            unique_key: 37,
            value: '香川県'
        },
        {
            unique_key: 38,
            value: '愛媛県'
        },
        {
            unique_key: 39,
            value: '高知県'
        },
        {
            unique_key: 40,
            value: '福岡県'
        },
        {
            unique_key: 41,
            value: '佐賀県'
        },
        {
            unique_key: 42,
            value: '長崎県'
        },
        {
            unique_key: 43,
            value: '熊本県'
        },
        {
            unique_key: 44,
            value: '大分県'
        },
        {
            unique_key: 45,
            value: '宮崎県'
        },
        {
            unique_key: 46,
            value: '鹿児島県'
        },
        {
            unique_key: 47,
            value: '沖縄県'
        }
    ];
};

const DISPLAY_CONTENT_BLOCK_REMAINING = [
    {
        id: 1,
        name: '残数を表示'
    },
    {
        id: 2,
        name: '残数割合に応じてラベルを表示'
    }
];

const LIST_MATCHING_CONDITION = [
    {
        id: 1,
        value: '大文字/小文字を区別する'
    },
    {
        id: 2,
        value: '全角/半角を区別する'
    },
    {
        id: 3,
        value: 'ひらがな/カタカナを区別する'
    }
];

const OPTION_SOURCE_PARAMS = [
    {
        id: 1,
        value: 'パラメータ'
    },
    {
        id: 2,
        value: 'HTTPヘッダ'
    },
    {
        id: 3,
        value: 'Cookie'
    }
];

const BGR_DEFAULT = (data) => {
    return {
        bg_question: data?.question_background_color ?? '',
        bg_answer: data?.answer_background_color ?? ''
    };
};

const CONFIG_FIELD_OPTION_PREV = (data = null) => {
    let maxLengthHandle = data?.max_characters ? data?.max_characters : '';
    if (data?.input_format?.type_input === 'numerical_value') {
        maxLengthHandle = Number(data?.max_characters) + 1;
    }
    return {
        configFieldRadio: {
            isRequired: false,
            error: false,
            errorField: '',
            valueSync: null,
            typesValidate: []
        },
        configFieldText: {
            classCustom: 'w-auto',
            size: data?.setting_others?.width_other || data?.input_field_size || '',
            maxlength: maxLengthHandle,
            placeholder: data?.placeholder || '',
            errorField: '',
            valueSync: '',
            messageCustom: true,
            isRequired: false,
            error: false,
            typesValidate: []
        },
        configFieldSelect: {
            trackBy: 'unique_key',
            label: 'value',
            errorField: '',
            placeholder: '',
            valueSync: null,
            error: false,
            isRemove: true,
            messageCustom: true,
            typesValidate: []
        },
        configFieldCheckbox: {
            classCustom: '',
            type: 'checkbox',
            errorField: '',
            valueSync: [],
            messageCustom: true,
            isRequired: false,
            error: false,
            typesValidate: []
        },
        configFieldProvince: {
            trackBy: 'unique_key',
            label: 'value',
            errorField: '',
            placeholder: '',
            valueSync: null,
            error: false,
            isRemove: true,
            typesValidate: []
        },
        configFieldTextarea: {
            placeholder: data?.placeholder || '',
            errorField: '',
            errorCustomMess: '',
            valueSync: '',
            length: '',
            maxlength: data.max_characters || 30000,
            error: false,
            typesValidate: []
        },
        configFieldPhone_1: {
            placeholder: data.block_phone.placeholder_1 || '',
            valueSync: '',
            maxlength: 5,
            isNumber: true,
            error: false
        },
        configFieldPhone_2: {
            placeholder: data.block_phone.placeholder_2 || '',
            valueSync: '',
            maxlength: 4,
            isNumber: true,
            error: false
        },
        configFieldPhone_3: {
            placeholder: data.block_phone.placeholder_3 || '',
            valueSync: '',
            maxlength: 4,
            isNumber: true,
            error: false
        },
        configFieldFirstName: {
            placeholder: data.block_full_name.placeholder_first_name || '',
            maxlength: data.max_characters,
            valueSync: '',
            error: false,
            typesValidate: []
        },
        configFieldLastName: {
            placeholder: data.block_full_name.placeholder_last_name || '',
            maxlength: data.max_characters,
            valueSync: '',
            error: false,
            typesValidate: []
        },
        configFieldPostcode_1: {
            placeholder: data.block_post_code.placeholder_1,
            valueSync: '',
            errorText: '',
            maxlength: 3,
            error: false
        },
        configFieldPostcode_2: {
            placeholder: data.block_post_code.placeholder_2,
            valueSync: '',
            errorText: '',
            maxlength: 4,
            error: false
        },
        configFieldKeywordBox: {
            autocomplete: 'new-password',
            type: data?.block_keyword_box?.field_mask_display === OPTION_YES_NO[0]?.id ? 'password' : 'text',
            classCustom: 'w-auto',
            placeholder: data?.placeholder || '',
            size: data.input_field_size || '',
            valueSync: '',
            maxlength: maxLengthHandle,
            error: false
        },
        configFieldDate: {
            minYear: data.block_date.format_year.lower_limit,
            maxYear: data.block_date.format_year.upper_limit,
            placeholder_year: data.block_date.format_year.placeholder,
            placeholder_month: data.block_date.format_month_day.placeholder_month,
            placeholder_day: data.block_date.format_month_day.placeholder_day,
            minDateYear: '1800/01/01',
            maxDateYear: '2100/12/31',
            errorField: '',
            valueSync: '',
            error: false,
            isSelectDate: false
        },
        configFieldAgeConditionValue: {
            isNumber: true,
            isMaxLength: true,
            length: 3,
            maxlength: 3,
            error: false,
            errorField: '年齢条件',
            errorCustomMess: '',
            valueSync: data?.block_input?.age_condition?.value ? data.block_input.age_condition.value : '',
            typesValidate: ['maxCustom']
        }
    };
};

const VALUE_DEFAULT_BLOCK = (data = null) => {
    if (!data) return;
    const conditionValueDefault = [ALL_BLOCK_TYPE.BLOCK_SELECT, ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE].includes(data.block_type)
        ? data?.default_choice ?? [data.option_unselected_label, ...data.option_value][0]
        : data?.default_choice ?? null;
    const valueSelectDateFault = { unique_key: null, value: '' };

    return {
        choiceValue: conditionValueDefault,
        choiceValues: data?.default_choices ?? [],
        textValue: FORMAT_VALUE_INPUT(data?.value_default_text, 0) ?? '',
        confirmTextValue: FORMAT_VALUE_INPUT(data?.value_default_text, 1) ?? '',
        phoneValue_1: FORMAT_VALUE_PHONE(data?.value_default_text, 0),
        phoneValue_2: FORMAT_VALUE_PHONE(data?.value_default_text, 1),
        phoneValue_3: FORMAT_VALUE_PHONE(data?.value_default_text, 2),
        placeholderFirstName: FORMAT_VALUE_PHONE(data?.value_default_text, 0),
        placeholderLastName: FORMAT_VALUE_PHONE(data?.value_default_text, 1),
        postcodeValue_1: FORMAT_VALUE_PHONE(data?.value_default_text, 0),
        postcodeValue_2: FORMAT_VALUE_PHONE(data?.value_default_text, 1),
        selectYear: data?.block_date?.select_value_default?.year ?? valueSelectDateFault,
        selectMonth: data?.block_date?.select_value_default?.month ?? valueSelectDateFault,
        selectDay: data?.block_date?.select_value_default?.day ?? valueSelectDateFault
    };
};

const OPTION_AGE_CONDITION = [
    { id: 1, value: '>' },
    { id: 2, value: '<' },
    { id: 3, value: '=' },
    { id: 4, value: '≧' },
    { id: 5, value: '≦' }
];

export {
    configFormInput,
    handleAddConfigOptions,
    CONFIG_FIELD_OPTION_PREV,
    VALUE_DEFAULT_BLOCK,
    LIST_PROVINCE_BLOCK,
    BGR_DEFAULT,
    CONFIRMATION_PAGE_DISPLAY,
    LIST_TEXT_ALIGN,
    LAYOUT_TYPE,
    LIST_CHOICE_CONDITION,
    MATCH_CHOICE_CONDITION,
    TABLE_OPTION_BLOCK_COMMON,
    TABLE_CONDITION_BLOCK,
    TYPE_CONDITION_IN_TABLE,
    OPTION_LIMIT_CHECK,
    OPTION_AGE_CONDITION,
    OPTION_INPUT_FORMAT,
    OPTION_YES_NO,
    OPTION_FORMAT_DATE,
    OPTION_CALENDAR_WEST_TIME,
    OPTION_INPUT_FORMAT_FULL_NAME,
    DISPLAY_CONTENT_BLOCK_REMAINING,
    LIST_MATCHING_CONDITION,
    OPTION_SOURCE_PARAMS,
    TABLE_ERROR_MESSAGES
};
